<template>
  <div class="roles-edit h-100">
    <template v-if="loading">
      <div class="loading">
        <GjIcon name="Loader" />
      </div>
    </template>
    <template v-else>
      <role-form
        :edit-role="role"
        details
        @submit="editRole"
        @close="onClose"
      />
    </template>
  </div>
</template>
<script>
import RoleForm from './Form.vue'

export default {
  name: 'EditRole',
  components: {
    RoleForm,
  },
  data() {
    return {
      roleId: null,
      loading: true,
    }
  },
  computed: {
    role() {
      return this.$store.state.roles.role
    },
  },
  created() {
    this.roleId = this.$route.params.id
    this.$store
      .dispatch('roles/getRole', this.roleId)
      .then(() => {
        this.loading = false
      })
      .catch(error => {
        this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while getting role.')
      })
  },
  methods: {
    editRole(role) {
      const query = {
        id: this.roleId,
        role,
      }
      this.$store
        .dispatch('roles/updateRole', query)
        .then(() => {
          this.successToast('Role was updated')
          this.onClose()
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating role.')
        })
    },

    onClose() {
      this.$router.push({ name: 'organization-settings', query: { tab: '2' } })
    },
  },
}
</script>
